import { trigger } from '@angular/animations';
import { CdkAccordionItem } from '@angular/cdk/accordion';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, Directive, HostBinding, inject, Optional, signal, ViewEncapsulation } from '@angular/core';
import { GALAXY_LIST_CONTAINER_TOKEN } from './list-container.component';
import { ICON_PLACEHOLDER } from './list-item.component';
import { GALAXY_LIST_OPTIONS, GALAXY_LIST_OPTIONS_TOKEN } from './list.config';
import { expansionAnimation } from './sublist.component.animations';

@Directive({ selector: 'glxy-sublist-content, [glxySublistContent]'})
export class GalaxySublistContentDirective {
  @HostBinding('class.glxy-sublist-content') readonly class = true;
}

const iconPlaceholderFactoryProvider = {
  provide: ICON_PLACEHOLDER,
  useFactory: (config?: GALAXY_LIST_OPTIONS) => {
    return config?.sublistContentSpacer ?? { width: 24, height: 24 };
  },
  deps: [[new Optional(), GALAXY_LIST_OPTIONS_TOKEN]],
};

@Component({
  selector: 'glxy-sublist',
  imports: [NgClass, NgTemplateOutlet],
  templateUrl: './sublist.component.html',
  styleUrls: ['./sublist.component.scss', './sublist-legacy.component.scss'],
  host: {
    '[class.glxy-list-default]': 'designVersion() === "default" || !designVersion()',
    '[class.glxy-list-legacy]': 'designVersion() === "legacy"',
  },
  encapsulation: ViewEncapsulation.None,
  animations: [trigger('openClose', expansionAnimation)],
  providers: [
    iconPlaceholderFactoryProvider,
    {
      provide: CdkAccordionItem,
      useExisting: GalaxySublistComponent,
    },
  ],
})
export class GalaxySublistComponent extends CdkAccordionItem {
  protected designVersion = inject(GALAXY_LIST_CONTAINER_TOKEN, { optional: true })?.designVersion ?? signal('default');

  isInContainer = !!this.accordion;
}
